<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="for"><span class="epub-b">FOREWORD</span></p>
<p class="co">The first known version of the Rapunzel fairy tale was ‘Petrosinella’ (‘Little Parsley’), by the Italian writer Giambattista Basile (c.1575–1632), published posthumously in 1634.</p>
<p class="tx">Sixty-four years later, in 1698, it was retold under the name ‘Persinette’ by the French writer Charlotte-Rose de Caumont de la Force (1650–1724), written while she was locked away in a nunnery as punishment for her scandalous life. She changed the ending so that her heroine’s tears healed the eyes of the blinded prince and the witch was redeemed.</p>
<p class="tx">Fairy-tale scholars have always been puzzled by how Mademoiselle de la Force could have come to know Basile’s story. His work was not translated from his native Neapolitan dialect for many years after Mademoiselle de la Force’s death, and, although she was unusually well educated for her time, she never travelled to Italy, nor could she speak Neapolitan. It is her version of the tale that we now know as ‘Rapunzel’.</p>
<p class="tx">As well as being one of the first writers of literary fairy tales, Mademoiselle de la Force was one of the first writers of historical fiction and was known to be a major influence on Sir Walter Scott, who is commonly regarded as the ‘father’ of historical fiction.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fore.vue?1abc4a83